import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ApparelLogin from "../Components/apparelLogin";
import BarcodeListScreen from "../Components/barcodeListScreen";
import Billing from "../Components/billing";
import CreateBill from "../Components/createBill";
import Customer from "../Components/customer";
import CustomerCreditLedger from "../Components/users/CustomerCreditLedger";
import SalesReport from "../Components/Reports/salesReport";
import ReportSubmenu from "../Components/SubComponents/reportSubmenu";
import { AppReferenceId } from "../Globals/AppReferenceId";
import { getAuthToken, getUser } from "../Utils/localStorage";
import { routeAdminRole } from "./NavigateAccess";
import NotFound from "./NotFound";
import { PrivateNavigates } from "./PrivateNavigates";
import CycleCount from "../Components/cycleCount";
import AttendanceList from "../Components/attendance/attendanceList";
import EmployeeAttendanceCalendar from "../Components/attendance/employeeAttendanceCalendar";
import IndividualCycleIdSubmenu from "../Components/SubComponents/individualCycleIdSubmenu";
import IndividualCycleId from "../Components/individualCycleId";
import InventoryManagement from "../Components/inventoryManagement";
import StockHistory from "../Components/stockHistory";
import StockMovementHistory from "../Components/stockMovementHistory";
import ReportListScreen from "../Components/Reports/ReportListScreen";
import DashboardScreen from "../Components/Reports/Dashboard/DashboardScreen";
import SalesDashboardScreen from "../Components/Reports/Dashboard/SalesDashboardScreen";
import InventoryDashboardScreen from "../Components/Reports/Dashboard/InventoryDashboardScreen";
import CustomerDashboardScreen from "../Components/Reports/Dashboard/CustomerDashboardScreen";
import VendorDashboardScreen from "../Components/Reports/Dashboard/VendorDashboardScreen";
import EmployeeDashboardScreen from "../Components/Reports/Dashboard/EmployeeDashboardScreen";
import CustomDashboardScreen from "../Components/Reports/Dashboard/CustomDashboardScreen";
import CustomerCreditDashboardScreen from "../Components/Reports/Dashboard/CustomerCreditDashboardScreen";
import VendorDebtDashboardScreen from "../Components/Reports/Dashboard/VendorDebtDashboardScreen";
import FeedbackDashboardScreen from "../Components/Reports/Dashboard/FeedbackDashboardScreen";
import FeedbackListScreen from "../Components/Feedback/FeedbackListScreen";
import VendorList from "../Components/vendorList";
import CreateVendor from "../Components/createVendor";
import VendorPurchaseHistory from "../Components/vendor/VendorPurchaseHistory";
import RentalScreen from "../Components/rental/RentalScreen";
import VendorDebtLedger from "../Components/vendor/VendorDebtLedger";
import Procurement from "../Components/procurement";
import SalesReturn from "../Components/salesReturn";
import CustomerAdmin from "../Mugizh-admin/customer";
import Vendors from "../Mugizh-admin/vendors";
import Employee from "../Mugizh-admin/employee";
import Banner from "../Mugizh-admin/banner";
import Report from "../Mugizh-admin/report";
import Category from "../Mugizh-admin/category";
import MyOrdersList from "../Mugizh-admin/myOrdersList";
import Dashboard from "../Mugizh-admin/dashBoard";
import AuditLog from "../Mugizh-admin/auditLog";
import Festival from "../Mugizh-admin/festival";
import HotNew from "../Components/SubComponents/hotNew";
import TopPicks from "../Components/SubComponents/topPicks";
import OnlineBilling from "../Components/onlineBilling";
import ThemeDemo from "../theme/ThemeDemo.demo"; // Phase 0 design-system sandbox (dev only)
import AppShell from "../shared/app-shell"; // Phase 1 application shell (sidebar + topbar)
import ComponentsDemo from "../shared/ComponentsDemo.demo"; // Phase 2 shared-component sandbox (dev only)

function Navigates() {

    const logginUser = getUser();
    const roleId = logginUser?.roleId;

    const haveAccess = (screen: any) => {
        if (roleId == 1) {
            return routeAdminRole?.includes(screen);
        }
    }
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={<Navigate to={"/login"} />}
                />
                {/* <Route
                path='login'
                element={</>}/> */}
                <Route path="/login" element={<ApparelLogin />} />
                {/* Phase 1: all authenticated screens render inside the AppShell
                    (sidebar + topbar). Route paths, PrivateNavigates guards and
                    haveAccess() gating below are unchanged — only wrapped. */}
                <Route element={<AppShell />}>
                    <Route path="/inventoryManagement" element={<PrivateNavigates>{haveAccess("/inventoryManagement") == true ? <InventoryManagement /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/stock/history" element={<PrivateNavigates>{haveAccess("/inventoryManagement") == true ? <StockHistory /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/inventoryManagement/stock-history" element={<PrivateNavigates>{haveAccess("/inventoryManagement") == true ? <StockMovementHistory /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/billing" element={<PrivateNavigates><Billing /></PrivateNavigates>} />
                    <Route path="/create/bill" element={<PrivateNavigates><CreateBill /></PrivateNavigates>} />
                    <Route path="/customer" element={<PrivateNavigates>{haveAccess("/customer") == true ? <Customer /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/credit-ledger/:customerId" element={<PrivateNavigates>{haveAccess("/credit-ledger") == true ? <CustomerCreditLedger /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/sales/report" element={<PrivateNavigates>{haveAccess("/sales/report") == true ? <SalesReport /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/reports/sales" element={<PrivateNavigates>{haveAccess("/reports/sales") == true ? <ReportSubmenu /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/barcode/list" element={<PrivateNavigates>{haveAccess("/barcode/list") == true ? <BarcodeListScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/cycle/count" element={<CycleCount />} />
                    <Route path="/attendance" element={<PrivateNavigates>{haveAccess("/attendance") == true ? <AttendanceList /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/attendance/:employeeId" element={<PrivateNavigates>{haveAccess("/attendance") == true ? <EmployeeAttendanceCalendar /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/cycle/singleandmultiple" element={<IndividualCycleId />} />
                    <Route path="/vendor" element={<VendorList />} />
                    <Route path="/vendor/create" element={<CreateVendor />} />
                    <Route path="/vendor-purchase" element={<VendorPurchaseHistory />} />
                    <Route path="/vendor-debt/:vendorId" element={<PrivateNavigates>{haveAccess("/vendor-debt") == true ? <VendorDebtLedger /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/report/list" element={<ReportListScreen />} />
                    <Route path="/report/dashboard" element={<DashboardScreen />} />
                    <Route path="/report/sales-dashboard" element={<SalesDashboardScreen />} />
                    <Route path="/report/inventory-dashboard" element={<InventoryDashboardScreen />} />
                    <Route path="/report/customer-dashboard" element={<CustomerDashboardScreen />} />
                    <Route path="/report/vendor-dashboard" element={<VendorDashboardScreen />} />
                    <Route path="/report/employee-dashboard" element={<EmployeeDashboardScreen />} />
                    <Route path="/report/custom-dashboard" element={<CustomDashboardScreen />} />
                    <Route path="/report/customer-credit-dashboard" element={<PrivateNavigates>{haveAccess("/report/customer-credit-dashboard") == true ? <CustomerCreditDashboardScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/report/vendor-debt-dashboard" element={<PrivateNavigates>{haveAccess("/report/vendor-debt-dashboard") == true ? <VendorDebtDashboardScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/report/feedback-dashboard" element={<PrivateNavigates>{haveAccess("/report/feedback-dashboard") == true ? <FeedbackDashboardScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/feedback/list" element={<PrivateNavigates>{haveAccess("/feedback/list") == true ? <FeedbackListScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/rental" element={<PrivateNavigates>{haveAccess("/rental") == true ? <RentalScreen /> : <NotFound />}</PrivateNavigates>} />
                    <Route path="/procurement" element={<Procurement />} />
                    <Route path="/salesReturn" element={<SalesReturn />} />
                    {/* <Route path="/mugizh-admin" element={<AdminMain />}> */}
                    <Route path="/mugizh-admin/customer" element={<CustomerAdmin />} />
                    <Route path="/mugizh-admin/vendor" element={<Vendors />} />
                    <Route path="/mugizh-admin/employee" element={<Employee />} />
                    <Route path="/mugizh-admin/audit-log" element={<AuditLog />} />
                    <Route path="/mugizh-admin/festival" element={<Festival />} />
                    <Route path="/mugizh-admin/banner" element={<Banner />} />
                    <Route path="/mugizh-admin/reports" element={<Report />} />
                    <Route path="/mugizh-admin/category" element={<Category />} />
                    <Route path="/mugizh-admin/dashboard" element={<Dashboard />} />
                    <Route path="/mugizh-admin/my-orders-list" element={<MyOrdersList />} />
                    <Route path="/mugizh-admin/hot-new" element={<HotNew />} />
                    <Route path="/mugizh-admin/top-picks" element={<TopPicks />} />
                    <Route path="/orders/online-billing" element={<OnlineBilling />} />
                </Route>
                {/* Phase 0: design-system sandbox — additive dev route, no guard, no existing route touched */}
                <Route path="/theme-demo" element={<ThemeDemo />} />
                {/* Phase 2: shared component library sandbox — additive dev route */}
                <Route path="/components-demo" element={<ComponentsDemo />} />

                {/* </Route> */}
            </Routes>
        </BrowserRouter>
    );
}

export default Navigates;